import { useContext } from 'react';
import { AppContext } from '@/context/AppContext';
import { ChevronDown, BarChart3, Settings } from 'lucide-react';
import ClientSwitcher from './ClientSwitcher';

export default function Header() {
  const { activeView, setActiveView, activeClient } = useContext(AppContext);

  return (
    <header className="sticky top-0 z-40 bg-[#0A0F1E]/95 backdrop-blur-sm border-b border-[#1E2D45]" data-testid="header">
      <div className="max-w-[1320px] mx-auto px-4 sm:px-5 py-3 sm:py-4">
        {/* Mobile: Stack vertically | Tablet+: Row layout */}
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-4">
          
          {/* Top row on mobile: Logo + Nav */}
          <div className="flex items-center justify-between sm:justify-start sm:flex-1">
            {/* Logo */}
            <div className="flex items-center gap-2 sm:gap-3">
              <div className="w-7 h-7 sm:w-8 sm:h-8 bg-gradient-to-br from-[#00C48C] to-[#0070F3] rounded-lg flex items-center justify-center">
                <BarChart3 size={16} className="text-black sm:w-[18px] sm:h-[18px]" />
              </div>
              <div>
                <h1 className="text-base sm:text-lg font-bold font-syne text-[#E2E8F0]">SEO Rank Intelligence</h1>
                <p className="text-[9px] sm:text-[10px] font-mono text-[#4A5568] uppercase tracking-wider">Live SERP Tracking</p>
              </div>
            </div>

            {/* Navigation - visible on mobile in top row */}
            <nav className="flex items-center gap-1 sm:hidden">
              <button
                onClick={() => setActiveView('dashboard')}
                className={`p-2 rounded-lg font-syne font-semibold text-xs transition-all ${
                  activeView === 'dashboard'
                    ? 'bg-[#1A2338] text-[#E2E8F0]'
                    : 'text-[#94A3B8] hover:text-[#E2E8F0]'
                }`}
                data-testid="nav-dashboard"
              >
                <BarChart3 size={18} />
              </button>
              <button
                onClick={() => setActiveView('admin')}
                className={`p-2 rounded-lg font-syne font-semibold text-xs transition-all ${
                  activeView === 'admin'
                    ? 'bg-[#1A2338] text-[#E2E8F0]'
                    : 'text-[#94A3B8] hover:text-[#E2E8F0]'
                }`}
                data-testid="nav-admin"
              >
                <Settings size={18} />
              </button>
            </nav>
          </div>

          {/* Client Switcher - stacks below logo on mobile */}
          <div className="w-full sm:w-auto">
            <ClientSwitcher />
          </div>

          {/* Navigation - hidden on mobile, visible on tablet+ */}
          <nav className="hidden sm:flex items-center gap-2">
            <button
              onClick={() => setActiveView('dashboard')}
              className={`px-3 lg:px-4 py-2 rounded-lg font-syne font-semibold text-sm transition-all ${
                activeView === 'dashboard'
                  ? 'bg-[#1A2338] text-[#E2E8F0]'
                  : 'text-[#94A3B8] hover:text-[#E2E8F0]'
              }`}
              data-testid="nav-dashboard-desktop"
            >
              <BarChart3 size={16} className="inline mr-1 lg:mr-2" />
              Dashboard
            </button>
            <button
              onClick={() => setActiveView('admin')}
              className={`px-3 lg:px-4 py-2 rounded-lg font-syne font-semibold text-sm transition-all ${
                activeView === 'admin'
                  ? 'bg-[#1A2338] text-[#E2E8F0]'
                  : 'text-[#94A3B8] hover:text-[#E2E8F0]'
              }`}
              data-testid="nav-admin-desktop"
            >
              <Settings size={16} className="inline mr-1 lg:mr-2" />
              Admin
            </button>
          </nav>
        </div>
      </div>
    </header>
  );
}
